function setStocksReturns(data) {
	return {
		type: 'SET_STOCKS_RETURNS',
		payload: data,
	};
}

export { setStocksReturns };
